import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-beige-300 bg-white px-6 py-14 sm:px-10" data-id="element-38" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center gap-6 text-center" data-id="element-39" data-mp="3gg0xbxz0nnv0">
        <p className="font-serif text-lg font-light tracking-wide text-warmgray-700" data-id="element-40" data-mp="32p5m4f11ouo9">
          Diagnóstico de piel
        </p>
        <p className="max-w-md text-xs font-light leading-relaxed text-warmgray-400" data-id="element-41" data-mp="36nd57gize82m">
          Esta herramienta ofrece una orientación general y no reemplaza una
          consulta dermatológica.
        </p>
        <p className="text-[0.7rem] uppercase tracking-[0.24em] text-warmgray-400" data-id="element-42" data-mp="36d44znhyxod">
          © {new Date().getFullYear()} Gaby
        </p>
      </div>
    </footer>;
}